import { mapActions, mapState } from 'vuex';
import switchButton from '@/components/generics/switch-button/switch-button.vue';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    obj: Object,
    category: String,
  },
  components: {
    switchButton,
  },
  data() {
    return {
      checked: false,
    };
  },
  computed: {
    ...mapState('profile', ['settings']),
    classObject() {
      return {
        'settings-option': true,
        'settings-option--disabled': this.disabled,
      };
    },
  },
  methods: {
    ...mapActions('profile', ['updateSettings']),
    toggle(e) {
      this.loaderAdd();
      this.checked = e;
      this.updateSettings({
        category: this.category,
        key: this.obj.key,
        value: e,
      })
      .then(() => this.loaderRemove())
      .catch(() => {
        this.loaderRemove();
        this.checked = !e;
        this.$emit('error', `Could not set "${this.obj.info}"`);
      });
      this.$emit('toggle', e);
    },
  },
  created() {
    const k = this.settings[this.category][this.obj.key];
    this.checked = k !== undefined ? k : false;
  },
};



// WEBPACK FOOTER //
// ./src/components/account/settings/settings-option/settings-option.js